export const MARKET_PREFERENCE_KEY = 'selectedMarket';
export const BANNER_HIDDEN_KEY = 'countryFilterBannerHidden';
export const DEFAULT_MARKET = process.env.REACT_APP_DEFAULT_MARKET || 'EU,UK';

export const COUNTRY_TO_MARKET = {
  // EU countries
  AT: 'EU',
  BE: 'EU',
  BG: 'EU',
  HR: 'EU',
  CY: 'EU',
  CZ: 'EU',
  DK: 'EU',
  EE: 'EU',
  FI: 'EU',
  FR: 'EU',
  DE: 'EU',
  GR: 'EU',
  HU: 'EU',
  IE: 'EU',
  IT: 'EU',
  LV: 'EU',
  LT: 'EU',
  LU: 'EU',
  MT: 'EU',
  NL: 'EU',
  PL: 'EU',
  PT: 'EU',
  RO: 'EU',
  SK: 'EU',
  SI: 'EU',
  ES: 'EU',
  SE: 'EU',
  // UK
  GB: 'UK',
  UK: 'UK',
};

/**
 * Convert a country code to its market (EU, UK)
 *
 * @param {String} countryCode - Country code to convert
 * @returns {String|undefined} Market code or undefined if not found
 */
export const countryCodeToMarket = countryCode => {
  return countryCode ? COUNTRY_TO_MARKET[countryCode.toUpperCase()] : undefined;
};

/**
 * Convert a market to a list of country codes in that market
 *
 * @param {String} market - Market code (EU, UK)
 * @returns {Array} List of country codes in the market
 */
export const marketToCountryCodes = market => {
  if (!market) return [];
  const upperMarket = market.toUpperCase();
  return Object.keys(COUNTRY_TO_MARKET).filter(
    country => COUNTRY_TO_MARKET[country] === upperMarket
  );
};

/**
 * Filters country codes based on listing/variant market and shippingTo restrictions
 *
 * @param {Array} countryCodes - Array of country code objects with { code, name }
 * @param {Object} listing - The listing or variant object (uses attributes.publicData.market)
 * @param {Object} shippingTo - Specific shipping countries (uses shippingTo.countries array)
 * @returns {Array} Filtered country codes
 */
export const filterCountriesByListingMarket = (countryCodes, listing, shippingTo) => {
  let filteredCountries = countryCodes;

  // Filter 1: Apply manual shippingTo country list if defined
  if (shippingTo && shippingTo.countries && shippingTo.countries.length > 0) {
    filteredCountries = filteredCountries.filter(country =>
      shippingTo.countries.includes(country.code)
    );
  }

  // Filter 2: Apply market-based restrictions (EU/UK) if defined
  const marketValue = listing?.attributes?.publicData?.market;

  // Apply market filter if present
  if (marketValue) {
    // Filter to only include countries that belong to the specified market
    filteredCountries = filteredCountries.filter(country =>
      marketToCountryCodes(marketValue).includes(country.code)
    );
  }

  return filteredCountries;
};
